import { render, staticRenderFns } from "./nextPostBtn.vue?vue&type=template&id=40401a1c&scoped=true&"
import script from "./nextPostBtn.vue?vue&type=script&lang=js&"
export * from "./nextPostBtn.vue?vue&type=script&lang=js&"
import style0 from "./nextPostBtn.vue?vue&type=style&index=0&id=40401a1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40401a1c",
  null
  
)

export default component.exports